module.exports = __webpack_public_path__ + "static/media/inB2.539af9df.png";